module.exports = __webpack_public_path__ + "img/link-45deg.bc6b55d5.svg";